import React from "react";
import { Routes, Route } from "react-router-dom";

import Dashboard from "./pages/dashboard/Dashboard";
import Projects from "./pages/projects/Projects";
import DentalIndentificationLayout from "./components/layout/layout";
import CreateNewProject from "./pages/projects/new-project/CreateNewProject";
import ProjectDetails from "./pages/projects/project-details/ProjectDetails";
import AMCaseRegistration from "./pages/projects/case-registrations/AM/AMCaseRegistration";
import PMCaseRegistration from "./pages/projects/case-registrations/PM/PMCaseRegistration";
import AddDentalRecord from "./pages/projects/add-dental-record/AddDentalRecord";
import SingleCaseResultDetail from "./pages/projects/project-details/single-case-result-details/SingleCaseResultDetail";
import SingleCaseAllRecords from "./pages/projects/project-details/single-case-all-records/SingleCaseAllRecords";
import MyProfileScreen from "./pages/side-menu-pages/side-menu-profile/MyProfileScreen";
import SupportScreen from "./pages/side-menu-pages/side-menu-support/SupportScreen";
import SettingsScreen from "./pages/side-menu-pages/side-menu-settings/SettingsScreen";
import AboutUsScreen from "./pages/side-menu-pages/side-menu-aboutus/AboutUsScreen";
import Breadcrumb from "./components/breadcrumb/Breadcrumb";
import PermissionDenied from "./pages/PermissionDenied";

const DentalIdentificationRoutes = () => {
  return (
    <Routes>
      <Route element={<DentalIndentificationLayout />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/new-project" element={<CreateNewProject />} />
        <Route path="/projects/details" element={<ProjectDetails />} />
        <Route
          path="/projects/details/case-registration/am"
          element={<AMCaseRegistration />}
        />
        <Route
          path="/projects/details/case-registration/pm"
          element={<PMCaseRegistration />}
        />
        <Route
          path="/projects/details/case/add-dental-record"
          element={<AddDentalRecord />}
        />
        <Route
          path="/projects/details/case/results/:id"
          element={<SingleCaseResultDetail />}
        />
        <Route
          path="/projects/details/case/all-records/:id"
          element={<SingleCaseAllRecords />}
        />
        <Route path="/profile" element={<MyProfileScreen />} />
        <Route path="/support" element={<SupportScreen />} />
        <Route path="/settings" element={<SettingsScreen />} />
        <Route path="/about-us" element={<AboutUsScreen />} />
        <Route path="/permission-denied" element={<PermissionDenied />} />
      </Route>
    </Routes>
  );
};

export default DentalIdentificationRoutes;
